module.exports = __webpack_public_path__ + "assets/img/26_755_big.3797566b.jpg";